import Vue from 'vue'
import VModal from 'vue-js-modal/dist/ssr.nocss'

import 'vue-js-modal/dist/styles.css'

// eslint-disable-next-line vue/component-definition-name-casing
Vue.use(VModal)
